import validate from "C:/Users/csb/Documents/GitHub/RiggingCalculator/node_modules/nuxt/dist/pages/runtime/validate.js";
import page_45global from "C:/Users/csb/Documents/GitHub/RiggingCalculator/middleware/page.global.ts";
import manifest_45route_45rule from "C:/Users/csb/Documents/GitHub/RiggingCalculator/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  page_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}